import * as yup from "yup";
import { useForm } from "react-hook-form";
import { useEffect, useMemo } from "react";
import { useYupValidationResolver } from "../../../../hooks/useYupValidationResolver";
import { useTranslate } from "../../../../hooks/useTranslate";
import { isVersionUK } from "../../../../services/versionService";

const validationSchema = yup.object({
    homeSchoolTeacherName: yup.string().required("formErrors.required"),
    homeSchoolTeacherRelationship: yup.string().required("formErrors.required"),
    homeSchoolTeacherEmail: yup.string(),
    homeSchoolTeacherPhone: yup.string(),
    homeSchoolSubjectsStudied: yup.string().required("formErrors.required"),
    homeSchoolAssessmentMethods: yup.string().required("formErrors.required"),
    homeSchoolPreviousEducationExperience: yup.string().required("formErrors.required"),
    homeSchoolExtracurricularActivities: yup.string(),
    homeSchoolAdditionalInformation: yup.string(),
    previousInstitutionFrom: yup.string().required("formErrors.required"),
    previousInstitutionTo: yup.string().required("formErrors.required"),
    ...(isVersionUK ? { reasonForJoining: yup.string().required("formErrors.required") } : {}),
});

const emptyFields = {
    homeSchoolTeacherName: "",
    homeSchoolTeacherRelationship: "",
    homeSchoolTeacherEmail: "",
    homeSchoolTeacherPhone: "",
    homeSchoolSubjectsStudied: "",
    homeSchoolAssessmentMethods: "",
    homeSchoolPreviousEducationExperience: "",
    homeSchoolExtracurricularActivities: "",
    homeSchoolAdditionalInformation: "",
    previousInstitutionFrom: "",
    previousInstitutionTo: "",
    ...(isVersionUK ? { reasonForJoining: "" } : {}),
};

export const useHomeSchoolForm = (data) => {
    const defaultValues = useMemo(() => {
        const dataWithoutNull = Object.fromEntries(Object.entries(data || {})
            .filter(([key]) => key in emptyFields)
            .filter(([, value]) => value !== null));

        return {
            ...emptyFields,
            ...dataWithoutNull,
        };
    }, [data]);
    const resolver = useYupValidationResolver(validationSchema);
    const { t } = useTranslate();

    const {
        control,
        handleSubmit,
        register,
        reset,
        formState: { errors: errorsKeys },
    } = useForm({
        resolver,
        defaultValues,
        mode: "onChange",
    });

    useEffect(() => {
        reset(defaultValues);
    }, [defaultValues]);

    const errors = Object.fromEntries(Object
        .entries(errorsKeys || {})
        .map(([key, { message, ...value }]) => [key, { ...value, message: t(message) }]));

    return {
        control,
        register,
        handleSubmit,
        reset,
        errors,
    };
};
